import React from 'react';
import { genPath } from '../utils';
export const BorderedBar = ({ barBorderRadius, fill, x, y, width, height, value }) => {
    return React.createElement("path", { d: genPath({ x, y, width, height, barBorderRadius, value }), fill: fill });
};
